



















































import { Guid } from 'guid-typescript'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import ModelSetter from '../../../../Mixins/ModelSetter'
import { tgLoginLink } from '../../../../shared/utils/tgLoginHelpers'
import Icon from "../../../Icon/Icon.vue";
import MessageEditorWithMediaInput from '../../../Pi/fields/NewMessageEditorWithMediaInput/MessageEditorWithMediaInput.vue'
import { User } from '../Users/types'
import {
  UserSendMessageComponent,
  UserSendMessageConfigType,
  UserSendMessageExtraItems,
  UserSendMessageLink
} from './types'

type MarkedItem<T> = T & {
  id: string
}

@Component({
  components: {
    Icon,
    MessageEditorWithMediaInput
  },
  data() {
    return {
      tgLoginLink
    }
  }
})
export default class UserSendMessage extends Mixins<ModelSetter>(ModelSetter) {
  @Prop() login!: string

  @Prop() userId!: number

  @Prop() state!: User['state']

  @Prop() extraItems!:UserSendMessageExtraItems

  @Prop({ type: String, default: 'full' }) mode!: 'full' | 'slim'

  currentItem: MarkedItem<UserSendMessageComponent> | MarkedItem<UserSendMessageLink> | null = null

  get markedExtraItems() {
    if (typeof this.extraItems === 'function') {
      return this.extraItems(this.userId, this.login, this.state).map(i => ({ ...i, id: Guid.create().toString() }))
    }

    return []
  }

  handleSelected(item: MarkedItem<UserSendMessageComponent> | MarkedItem<UserSendMessageLink>) {
    if (item.type === UserSendMessageConfigType.Component) {
      this.currentItem = item
    } else {
      item.callback(this.userId, this.login)
    }
  }
}
